import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { KlarnaExpressButtonWrapperComponent } from './klarna-express-button-wrapper/klarna-express-button-wrapper.component';
import { KlarnaPlacementWrapperComponent } from './klarna-placement-wrapper/klarna-placement-wrapper.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
    declarations: [
        KlarnaExpressButtonWrapperComponent,
        KlarnaPlacementWrapperComponent
    ],
    imports: [ BrowserModule ], 
    exports: [KlarnaExpressButtonWrapperComponent, KlarnaPlacementWrapperComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebWrapperModule {}
